import React from 'react'
import { ChatContainer } from '../common/llm-interface/chat-container'
import { ChatBar } from '../common/llm-interface/chat-bar'
import { useLlm } from '../common/llm-interface/useLlm'


export const ChatInterface = () => {

	const { send, messages, awaitingResponse } = useLlm()

	return (
		<div>
			<ChatContainer messages={messages} />
			<ChatBar awaitingResponse={awaitingResponse} send={send} />
		</div>
	)
}
